import * as consts from 'consts/consts';
import React, { FC, useCallback, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import Page from 'views/Layout/Pages/Page';
import ObjectivesSettingsAdminPage from './ObjectivesSettingsAdminPage';
import ObjectiveTypesAdminPage from './ObjectiveTypesAdminPage';

const ObjectivesAdministrationPage: FC = () => {
  const { formatMessage } = useIntl();
  const createHandlerRef = useRef<(() => void) | null>(null);
  const [isTypesDisabled, setIsTypesDisabled] = useState(false);

  const handleCreateRef = useCallback((handler: () => void) => {
    createHandlerRef.current = handler;
  }, []);

  const handleDisabledChange = useCallback((disabled: boolean) => {
    setIsTypesDisabled(disabled);
  }, []);

  const tabs = [
    {
      path: consts.ADMINISTRATION_OBJECTIVES(formatMessage).path,
      paths: [
        consts.ADMINISTRATION_OBJECTIVES(formatMessage).path,
        consts.ADMINISTRATION_OBJECTIVES_SETTINGS(formatMessage).path,
      ],
      name: consts.ADMINISTRATION_OBJECTIVES_SETTINGS(formatMessage).name,
      content: <ObjectivesSettingsAdminPage />,
    },
    {
      path: consts.ADMINISTRATION_OBJECTIVES_TYPES(formatMessage).path,
      paths: [consts.ADMINISTRATION_OBJECTIVES_TYPES(formatMessage).path],
      name: consts.ADMINISTRATION_OBJECTIVES_TYPES(formatMessage).name,
      content: (
        <ObjectiveTypesAdminPage
          onCreateRef={handleCreateRef}
          onDisabledChange={handleDisabledChange}
        />
      ),
      action: (
        <Button
          color="primary"
          disabled={isTypesDisabled}
          onClick={() => createHandlerRef.current?.()}
        >
          <i className="fe fe-layers me-1" />
          <FormattedMessage
            id="app.views.administration.objectives_admin.create_type"
            defaultMessage="Create type"
          />
        </Button>
      ),
    },
  ];

  return (
    <Page
      title={consts.ADMINISTRATION_OBJECTIVES(formatMessage).name}
      forceShowTabs={true}
      tabs={tabs}
    />
  );
};

export default React.memo(ObjectivesAdministrationPage);
